import { z } from 'zod';

export const FilterValueSchema = z.object({
  id: z.string(),
  label: z.string(),
});
export type FilterValue = z.infer<typeof FilterValueSchema>;

export const FilterSchema = z.object({
  id: z.string(),
  order: z.number().optional(),
  label: z.string(),
  values: z.array(FilterValueSchema),
});
export type Filter = z.infer<typeof FilterSchema>;

export const CoreFiltersSchema = z.object({
  dateRange: z.object({
    from: z.preprocess(
      (v) => (v == null || v === '' ? undefined : v),
      z.coerce.date().optional(),
    ),
    to: z.preprocess(
      (v) => (v == null || v === '' ? undefined : v),
      z.coerce.date().optional(),
    ),
  }),
  domain: FilterSchema.optional(),
  siteId: FilterSchema.optional(),
});
export type CoreFilters = z.infer<typeof CoreFiltersSchema>;

// Battery hierarchy filters - supports both single and multiple values for flexibility
// Single values for higher levels, multiple values for lowest level
export const BatteryIdFiltersSchema = z.object({
  array: FilterSchema.optional(),
  node: FilterSchema.optional(),
  container: FilterSchema.optional(),
  bank: FilterSchema.optional(),
  pack: FilterSchema.optional(),
  module: FilterSchema.optional(),
});
export type BatteryIdFilters = z.infer<typeof BatteryIdFiltersSchema>;

// PCS hierarchy – single-level for now, but poised to grow
// Also supports multiple values for cases where PCS is the lowest level
export const PcsFiltersSchema = z.object({
  pcs: FilterSchema.optional(),
});
export type PcsFilters = z.infer<typeof PcsFiltersSchema>;

export const FiltersSchema = z.object({
  coreFilters: CoreFiltersSchema,
  batteryFilters: BatteryIdFiltersSchema,
  pcsFilters: PcsFiltersSchema,
});

export type Filters = z.infer<typeof FiltersSchema>;
